import {
  GlobalOutlined,
  HeartOutlined,
  RocketOutlined,
  SafetyOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AnimatedBackground from "../../components/common/AnimatedBackground";
import AnimatedLogo from "../../components/common/AnimatedLogo";
import AnimatedSparkles from "../../components/common/AnimatedSparkles";

export default function HomePage() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const goToLogin = () => {
    navigate("/login");
  };

  const features = [
    { icon: <SafetyOutlined />, text: "Bảo mật cao" },
    { icon: <ThunderboltOutlined />, text: "Hiệu suất tối ưu" },
    { icon: <GlobalOutlined />, text: "Truy cập mọi lúc" },
    { icon: <HeartOutlined />, text: "Dễ sử dụng" },
  ];

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-700 flex flex-col items-center justify-center p-4 relative overflow-hidden transition-all duration-500">
      <AnimatedBackground variant="home" />

      <AnimatedSparkles />

      <div className="relative z-10 flex flex-col items-center max-w-4xl mx-auto">
        <div
          className={`transform transition-all duration-1000 ${
            isVisible
              ? "translate-y-0 opacity-100 scale-100"
              : "translate-y-10 opacity-0 scale-95"
          }`}
        >
          <AnimatedLogo size="large" showStar={true} className="mb-12" />
        </div>

        <div
          className={`text-center mb-12 transform transition-all duration-1000 delay-300 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-600 via-red-600 to-red-600 bg-clip-text text-transparent drop-shadow-lg">
            TRACE - TEC
          </h1>

          <div className="relative">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 dark:text-white mb-4">
              Chào mừng bạn đến với hệ thống
            </h2>
            <div className="absolute -top-1 -right-8">
              <RocketOutlined className="text-blue-500 text-xl animate-bounce" />
            </div>
          </div>

          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 leading-relaxed max-w-2xl mx-auto">
            Khám phá và quản lý mọi thứ dễ dàng hơn với công nghệ hiện đại
          </p>
        </div>

        <div
          className={`grid grid-cols-2 md:grid-cols-4 gap-6 mb-12 transform transition-all duration-1000 delay-500 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center p-4 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group"
              style={{ animationDelay: `${600 + index * 100}ms` }}
            >
              <div className="text-2xl text-blue-500 mb-2 group-hover:animate-bounce">
                {feature.icon}
              </div>
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300 text-center">
                {feature.text}
              </span>
            </div>
          ))}
        </div>

        <div
          className={`transform transition-all duration-1000 delay-700 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <button
            onClick={goToLogin}
            className="group relative px-12 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold text-lg rounded-full shadow-2xl hover:shadow-blue-500/25 hover:scale-110 transition-all duration-300 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative flex items-center gap-3">
              <span>Bắt đầu ngay</span>
              <RocketOutlined className="text-xl group-hover:animate-bounce" />
            </div>

            <div className="absolute inset-0 -top-1 -left-1 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 group-hover:animate-pulse"></div>
          </button>
        </div>
        <div
          className={`mt-12 text-center transform transition-all duration-1000 delay-900 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <div className="flex items-center justify-center gap-4 text-sm text-gray-500 dark:text-gray-400">
            <span className="animate-pulse">✨ Hiện đại</span>
            <span className="animate-pulse" style={{ animationDelay: "0.5s" }}>
              🚀 Nhanh chóng
            </span>
            <span className="animate-pulse" style={{ animationDelay: "1s" }}>
              🔒 Bảo mật
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
